export const COMMON_COLORS = [
  '#F56565', // Red
  '#ED8936', // Orange
  '#D69E2E', // Dark Yellow
  '#48BB78', // Green
  '#4299E1', // Blue
  '#9F7AEA', // Purple
  '#ED64A6', // Pink
  '#2D3748', // Dark Gray
  '#38A169', // Dark Green
];
